export enum SharedExportAssociationType {
  PROGRAM = 'PROGRAM',
  PROJECT = 'PROJECT',
  MILESTONE = 'MILESTONE',
  PREQUALIFICATION = 'PREQUALIFICATION',
  PROJECT_GROUP = 'PROJECT_GROUP',
}
